









































































































































































































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { localGet, setMetaData, timeFormat } from "@/utils";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import { pagnition } from "@/utils/commonConfig";

@Component({
  name: "DataModuleDashboard",
  components: {},
})
export default class CombinationProperty extends Vue {
  @Provide() private activeName: string = "idInfo";
  @Provide() private roletype: number = 1; //用户角色
  // @Provide() private pvmetrics: any = {}; //数据
  @Provide() private updatetime: string = ""; //更新时间
  @Provide() private arg: any = {
    setUserid: 1039,
    Itemid: 201,
  }; //更新时间

  @Provide() private order: string = ""; //排名
  @Provide() private issearchDone: boolean = false;
  @Provide() private resultData: any = [];
  @Provide() private Userid: number | null = null;

  @Provide() private parameterData: any = []; //工单类型
  @Provide() private pvmetrics: any = {
    assignnum: "",
    avghandletime: "",
    completenum: "",
    inspectionpassnum: "",
    inspectionpassrate: "",
    invalidnum: "",
    invalidrate: "",
    passnum: "",
    passrate: "",
    rejectnum: "",
    rejectrate: "",
    ticketnum: "",
    time: "0s",
  };
  private created() {
    this.parameterData = [
      { id: 201, name: this.$t("ticketLgy.All") },
      { id: 100, name: "PV" },
      // { id: 107, name: "CPV" },
      { id: 101, name: "IR" },
      { id: 102, name: "QI" },
    ];
    this.searchStaffNum();
    let that = this;
    let timeRefrash = setInterval(function () {
      that.searchStaffNum();
    }, 5 * 60 * 1000);
  }
  //
  private changeUser(info: any) {
    if (this.roletype !== 1) {
      return;
    } else {
      let href: string =
        window.location.origin +
        window.location.pathname +
        "?userid=" +
        info.adminuid;
      window.open(href, "blank");
    }
  }
  //获取数据
  private async searchStaffNum() {
    this.issearchDone = true;
    this.$route.query.userid
      ? (this.Userid = Number(this.$route.query.userid))
      : null;
    this.Userid
      ? (this.arg.setUserid = this.Userid)
      : (this.arg.setUserid = Number(localGet("userid")));


    this.getIlstData();
    const { getPVDashboardReq, getPVDashboardRequest }: any = await import(
      "@/request/DataModule"
    );
    let res = await getPVDashboardRequest.handleHttp(
      getPVDashboardReq(this.arg),
      this
    );
    if (res && res.right) {
      // this.$message.success("successfully!");
      this.roletype = res.roletype;
      if (res.leaderpvmetrics) {
        this.pvmetrics = res.leaderpvmetrics;
      }
      if (res.pvmetrics) {
        this.pvmetrics = res.pvmetrics;
      }
      let time: string = "";
      let hour: number = 0;
      let min: number = 0;
      if ((this.pvmetrics.avghandletime * 1) / 3600 > 1) {
        hour = parseInt(`${this.pvmetrics.avghandletime / 3600}`);
        if ((this.pvmetrics.avghandletime % 3600) / 60 > 1) {
          min = parseInt(`${(this.pvmetrics.avghandletime % 3600) / 60}`);
          time = hour + "h" + min + "min";
        } else {
          time = hour + "h" + (this.pvmetrics.avghandletime % 3600) + "s";
        }
      } else {
        if ((this.pvmetrics.avghandletime % 3600) / 60 > 1) {
          min = parseInt(`${(this.pvmetrics.avghandletime % 3600) / 60}`);
          time = min + "min";
        } else {
          time = this.pvmetrics.avghandletime + "s";
        }
      }
      // this.pvmetrics.time =  this.pvmetrics.AvgHandleTime%360
      this.pvmetrics.time = time;
      this.updatetime = res.updatetime;
    } else {
    }
    this.issearchDone = false;
  }
  //获取列表数据
  private async getIlstData() {
    this.Userid
      ? (this.arg.setUserid = this.Userid)
      : (this.arg.setUserid = Number(localGet("userid")));
    const { getPVGroupStatsReq, getPVGroupStatsRequest }: any = await import(
      "@/request/DataModule"
    );
    let res = await getPVGroupStatsRequest.handleHttp(
      getPVGroupStatsReq(this.arg),
      this
    );
    if (res && res.right) {
      this.order = res.order;
      this.resultData = res.staffstatsList;
    } else {
    }
    this.issearchDone = false;
  }
  // private handleSizeChange(val: any) {
  //   this.pageSize = Number(val);
  //   //展示表格数据
  //   this.searchStaffNum();
  // }
  // private handleCurrentChange(val: any) {
  //   this.pageIndex = Number(val);
  //   //展示表格数据
  //   this.searchStaffNum();
  // }
  // //点击上一页
  // private handlePrevChange(val: any) {
  //   if (this.pageIndex > 0) {
  //     //展示表格数据
  //     this.searchStaffNum();
  //   }
  // }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.searchStaffNum();
  }
}
